import React from "react";
import "../App.css"; // Or wherever your global CSS is

const RobitoLogo = () => {
  return (
    <h1 className="robito-logo">
      MoriDapin<span className="dot-ai">.id</span>
    </h1>
  );
};

export default RobitoLogo;
